module.exports = __webpack_public_path__ + "media/images/common/cart_bg-f4e46c8e6b046d59628a9b6ab7f7e2bd.png";